import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useEnterprises() {
  const [enterprises, setEnterprises] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.users.enterprises.index)
      .then((response) => {
        setEnterprises(response.data.data);
      });
  }, []);

  return enterprises;
}
